namespace TR {
    class BoardTypeFilter {

        model: any;
        aggregate: any;
        limit: any;
        showAll: boolean;
        titles: any;
        boardArr: any;
        people: any;

        constructor(
            $scope: ng.IScope,
            resourceService: Core.ResourceService,
            occupancyService: Core.OccupancyService
        ) {
            const titles = {
                1: resourceService.get('ROOMONLY'),
                2: resourceService.get('BEDANDBREAKFAST'),
                3: resourceService.get('HALFBOARD'),
                4: resourceService.get('FULLBOARD'),
                5: resourceService.get('ALLINCLUSIVE'),
                6: resourceService.get('SELFCATERING')
            };

            $scope.$watch('bt.aggregate', agg => {
                if (!agg) { return; }
                let boardArr:any = [];
                for (let key in agg) {
                    boardArr.push(_.extend(agg[key], { id: key, title: titles[key] }));
                }
                _.set(
                    _.minBy(boardArr, (v:any) => v.MinPrice),
                    'cheapest',
                    true
                );
                this.boardArr = boardArr;
                this.people = occupancyService.getNumberOfNonInfantPassengers();
            });
        }

        isSet() {
            return !!_.size(this.model);
        }

        reset() {
            this.model = [];
        }

        more(all: boolean) {
            this.showAll = all;
        }

        showMoreLess() {
            return Object.keys(this.aggregate || {}).length > this.limit;
        }
    }

    angular
        .module('TR')
        .directive('boardTypeFilter', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=BoardTypeFilter',
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    limit: '@',
                    priceMode: '='
                },
                controller: BoardTypeFilter,
                controllerAs: 'bt'
            };
        });

    class BoardTypeFilterLabel {

        public static getTemplate() {
            return `
                <span ng-if="bt.isSet()">
                    <a
                        href="#"
                        ng-repeat="board in bt.model"
                        class="filter-criterion-toggle"
                        ng-click="bt.remove(board)">
                        <span> {{bt.getName(board)}} </span>
                    </a>
                </span>
            `;
        }

        model: any;
        aggregate: any;
        titles: any;

        constructor($scope: ng.IScope, resourceService: any, analytics: any) {
            this.titles = {
                1: resourceService.get('ROOMONLY'),
                2: resourceService.get('BEDANDBREAKFAST'),
                3: resourceService.get('HALFBOARD'),
                4: resourceService.get('FULLBOARD'),
                5: resourceService.get('ALLINCLUSIVE'),
                6: resourceService.get('SELFCATERING')
            };

            $scope.$watch('bt.model', (value: any) => {
                if (!value || !value.length) { return; }
                let boardType = value.map(v => this.getName(v));
                analytics.track(
                    'mixpanel',
                    'HolidayDealsFilterBoardTypes',
                    { value: boardType }
                );
            });
        }

        getName(board) {
            return this.titles[board];
        }

        isSet() {
            return !!_.size(this.model);
        }

        remove(board) {
            this.model = this.model.filter(v => v !== board);
        }
    }

    angular
        .module('TR')
        .directive('boardTypeFilterLabel', (): ng.IDirective => {
            return {
                scope: {},
                template: BoardTypeFilterLabel.getTemplate(),
                bindToController: {
                    model: '='
                },
                controller: BoardTypeFilterLabel,
                controllerAs: 'bt'
            };
        });

}
